module.exports = __webpack_public_path__ + "img/tertiary_11x3_z16.048bd0fb.svg";